interface LoadingStateProps {
  loading: boolean
  error: string | null
  onRetry: () => void
}

export function LoadingState({ loading, error, onRetry }: LoadingStateProps) {
  if (loading) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="text-text-muted text-body">Loading jobs...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="text-center">
          <div className="text-danger font-medium mb-2">Error loading jobs</div>
          <div className="text-small text-text-secondary">{error}</div>
          <button
            onClick={onRetry}
            className="mt-4 px-4 py-2 bg-brand-primary text-text-inverse rounded-md hover:bg-brand-primary-hover text-small min-h-11"
          >
            Retry
          </button>
        </div>
      </div>
    )
  }

  return null
}
